export enum LineType {
	FUNCTION_DECLARATION = 'function_declaration',
	DEFINE = 'define',
	BODY = 'body',
}
